import Api from '../api';

import { errorHandler } from '../common';
const { axios: api } = Api;

export const getSuperProducts = () =>
	errorHandler(async () => {
		const data = await api.get('/super-product');
		return { data: data.data };
	});

export const createSuperProduct = (payload) =>
	errorHandler(async () => {
		const data = await api.post('/super-product', payload);
		return { data: data.data };
	});

export const updateSuperProduct = (_id, payload) =>
	errorHandler(async () => {
		const data = await api.patch(`/super-product/${_id}`, payload);
		return { data: data.data };
	});
